import React from 'react'
import { Modal } from 'react-bootstrap'

const PopUpModal = ({
  visible,
  onCancel,
  link,
  page_format,
  file_type,
}) => {
  return (
    <Modal show={visible} onHide={onCancel} aria-labelledby="contained-modal-title-vcenter" size="lg" centered>
      <Modal.Body>
        {page_format === 'Image or PDF' && file_type === 'image' && (
          <img
            src={link}
            alt='Custom Page'
            title='Custom Page'
            style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
          />
        )}
        {page_format === 'Image or PDF' && file_type === 'pdf' && (
          <iframe title='Custom Page' src={link} style={{ width: '100%', height: '600px' }} />
        )}
      </Modal.Body>
    </Modal>
  )
}

export default PopUpModal
